<div class="modal-body">
  <p class="centermodal__title">{{ 'documents.govbrValidate.title' | translate }}</p>

  <div class="centermodal__message-body centermodal__message-body--margin-normal">
    <p class="centermodal__message">{{ 'documents.govbrValidate.description' | translate }}</p>
  </div>

  <div class="centermodal__form">
    <p class="govbr-steps__title">{{ 'documents.govbrValidate.howToTitle' | translate }}</p>

    <ol class="govbr-steps">
      <li>{{ 'documents.govbrValidate.step1' | translate }}</li>
      <li>{{ 'documents.govbrValidate.step2' | translate }}</li>
      <li>
        {{ 'documents.govbrValidate.step3' | translate }}
      </li>
    </ol>
    <div class="configuration-value">
      <span class="configuration-value-show">{{ certificateUrl }}</span>
      <div class="configuration-value-copy" (click)="copyUrl()" [ngxClipboard] [cbContent]="certificateUrl"></div>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled btn-filled-cancel" (click)="modal.dismiss()">
      {{ 'button.back' | translate }}
    </button>
    <button type="button" class="btn-M btn-filled icon-end" (click)="openValidator()">
      {{ 'documents.govbrValidate.accessValidator' | translate }}
      <i class="fal fa-external-link-alt ml-2"></i>
    </button>
  </div>
</div>
